// Business details used across the site. Values marked PLACEHOLDER still need real info.
export const SITE = {
  name: "ATA Forge",
  tagline: "Fast, modern websites for North Jersey small businesses, live in 7–10 days.",
  email: "info@ataforge.net",
  phone: "", // PLACEHOLDER: e.g. "(973) 000-0000"
  phoneHref: "", // PLACEHOLDER: e.g. "tel:+19730000000"
  bookCallUrl: "", // PLACEHOLDER: paste your booking link (Calendly, Google Calendar, etc.)
  city: "Wayne, NJ",
  serviceArea: "Wayne, NJ and about 30 miles around",
};

export const MOCKUP_LINK = "/contact?topic=Free%20mockup";

export const NAV_LINKS = [
  { to: "/work", label: "Work" },
  { to: "/services", label: "Services & Pricing" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

export const TOWNS = [
  "Wayne",
  "Totowa",
  "Little Falls",
  "Paterson",
  "Clifton",
  "Montclair",
  "Pompton Lakes",
  "Fairfield",
  "Montville",
  "Parsippany",
  "Morristown",
  "Ridgewood",
  "Paramus",
  "Hackensack",
  "Butler",
  "Lincoln Park",
];
